/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PromisScores,
    PromisScoresFromJSON,
    PromisScoresFromJSONTyped,
    PromisScoresToJSON,
} from './';

/**
 * 
 * @export
 * @interface SurveyData
 */
export interface SurveyData {
    /**
     * 
     * @type {string}
     * @memberof SurveyData
     */
    type: SurveyDataTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof SurveyData
     */
    date: Date;
    /**
     * 
     * @type {PromisScores}
     * @memberof SurveyData
     */
    promisScores: PromisScores;
    /**
     * 
     * @type {string}
     * @memberof SurveyData
     */
    riskCategory?: SurveyDataRiskCategoryEnum;
}

export function SurveyDataFromJSON(json: any): SurveyData {
    return SurveyDataFromJSONTyped(json, false);
}

export function SurveyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'date': (new Date(json['date'])),
        'promisScores': PromisScoresFromJSON(json['promis-scores']),
        'riskCategory': !exists(json, 'risk-category') ? undefined : json['risk-category'],
    };
}

export function SurveyDataToJSON(value?: SurveyData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'date': (value.date.toISOString()),
        'promis-scores': PromisScoresToJSON(value.promisScores),
        'risk-category': value.riskCategory,
    };
}

/**
* @export
* @enum {string}
*/
export enum SurveyDataTypeEnum {
    Onboarding = 'onboarding',
    Reassessment = 'reassessment'
}
/**
* @export
* @enum {string}
*/
export enum SurveyDataRiskCategoryEnum {
    Low = 'low',
    Moderate = 'moderate',
    High = 'high'
}


